module.exports = __webpack_public_path__ + "03_face.6f4f4987.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/03_face.png
// module id = V3+x
// module chunks = 0